import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { FaPlus, FaCheck, FaThumbsUp, FaTimes, FaTrash, FaEdit, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, FaSearch, FaRedo, FaCog, FaHandshake, FaCogs, FaInfoCircle, FaTicketAlt, FaMoneyBill } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import Select from "react-select";
import { getAuthToken } from '../../authToken';

const ListeSouscriptions = ({ titre }) => {
    useAuth();
    const [souscriptions, setSouscriptions] = useState([]);
    const [selectedSouscription, setSelectedSouscription] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = souscriptions.length;

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Souscriptions";
            fetchSouscriptions();
            fetchUtilisateur();
        }
    }, [user_id]);

    const [ListeCodePartenaire, setListeCodePartenaire] = useState([]);
    const [produits, setProduits] = useState([]);
    const [formation, setFormation] = useState([]);
    // REMPLACER: tableau par une valeur unique
    const [selectedFormation, setSelectedFormation] = useState('');
    const [selectedProduits, setSelectedProduits] = useState([]);
    const [activeTab, setActiveTab] = useState('formations');
    const [codePromo, setCodePromo] = useState('');
    const [codePartenaire, setCodePartenaire] = useState('');
    const carouselRef = useRef(null);
    const [translateX, setTranslateX] = useState(0);
    const itemWidth = 250;
    const itemsPerRow = 4;

    const fetchProduits = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-produit/');
            if (response.ok) {
                const data = await response.json();
                setProduits(data);
            } else {
                console.error('Erreur lors de la récupération des produits');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchCodePartenaire = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tous-code-partenaire/');
            if (response.ok) {
                const data = await response.json();
                setListeCodePartenaire(data.code_partenaires);
            } else {
                console.error('Erreur lors de la récupération des codes partenaires');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchFormation = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
            if (response.ok) {
                const data = await response.json();

                // Filtrer les formations actives avec date non dépassée
                const formationActive = data.filter(formation => {
                    // Vérifier que le statut est actif
                    if (formation.statut !== "actif") return false;

                    // Si la formation n'a pas de date, on la considère comme disponible
                    if (!formation.date || formation.date.trim() === "") return true;

                    // Vérifier si la date n'est pas encore passée
                    try {
                        const formationDate = new Date(formation.date);
                        const aujourdhui = new Date();

                        // Réinitialiser les heures pour comparer seulement les dates
                        formationDate.setHours(0, 0, 0, 0);
                        aujourdhui.setHours(0, 0, 0, 0);

                        return formationDate >= aujourdhui;
                    } catch (error) {
                        console.warn('Erreur de parsing de date pour la formation:', formation.nom, error);
                        return true; // En cas d'erreur, on garde la formation
                    }
                });

                setFormation(formationActive);
            } else {
                console.error('Erreur lors de la récupération des formations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        fetchProduits();
        fetchFormation();
        fetchCodePartenaire();
    }, []);

    // Fonction pour obtenir le prix de la formation
    const getPrixFormation = (formationItem) => {
        return formData.type_financement === 'Particulier' && formationItem.prix_particulier > 0
            ? formationItem.prix_particulier
            : formationItem.prix;
    };

    // Fonction pour obtenir le prix final après réduction
    const getPrixFinal = () => {
        if (selectedFormation) {
            const formationSelectionnee = formation.find(f => f.reference === selectedFormation);
            if (formationSelectionnee) {
                const prixBase = getPrixFormation(formationSelectionnee);
                return prixBase - reduction - reductionPartenaire;
            }
        }
        return 0;
    };

    const [formData, setFormData] = useState({});
    
        const fetchUtilisateur = async () => {
        try {
            const token = localStorage.getItem('access_token');
    
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            
            const data = await response.json();
            setFormData(data);
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur', error);
        }
    };

    const [reduction, setReduction] = useState(0);
    const [formationAvecPromo, setFormationAvecPromo] = useState(null);
    const [codePromoValide, setCodePromoValide] = useState(false);

    // Fonction pour vérifier le code promo
    const verifierCodePromo = (code) => {
        if (!code || !selectedFormation) {
            setReduction(0);
            setFormationAvecPromo(null);
            setCodePromoValide(false);
            return;
        }

        const formationSelectionnee = formation.find(f => f.reference === selectedFormation);
        if (!formationSelectionnee) {
            setReduction(0);
            setFormationAvecPromo(null);
            setCodePromoValide(false);
            return;
        }

        // Vérifier si le code correspond à la formation sélectionnée
        if (formationSelectionnee.code_formation &&
            formationSelectionnee.code_formation.toLowerCase() === code.toLowerCase()) {

            // Vérifier la date de validité du code promo
            const aujourdhui = new Date();
            aujourdhui.setHours(0, 0, 0, 0);

            const dateFinPromo = formationSelectionnee.date_fin_promo ?
                new Date(formationSelectionnee.date_fin_promo) : null;

            if (dateFinPromo) {
                dateFinPromo.setHours(0, 0, 0, 0);
            }

            const estValide = !dateFinPromo || aujourdhui <= dateFinPromo;

            if (estValide) {
                const pourcentageReduction = formationSelectionnee.pourcentage_promo || 0;
                const prixBase = getPrixFormation(formationSelectionnee);
                const montantReduction = (prixBase * pourcentageReduction) / 100;

                setReduction(montantReduction);
                setFormationAvecPromo(formationSelectionnee);
                setCodePromoValide(true);
            } else {
                setReduction(0);
                setFormationAvecPromo(null);
                setCodePromoValide(false);
            }
        } else {
            setReduction(0);
            setFormationAvecPromo(null);
            setCodePromoValide(false);
        }
    };

    const [reductionPartenaire, setReductionPartenaire] = useState(0);
    const [codePartenaireValide, setCodePartenaireValide] = useState(false);
    const [codePartenaireInfo, setCodePartenaireInfo] = useState(null);

    // Fonction pour vérifier le code partenaire
    const verifierCodePartenaire = (code) => {
        if (!code || !selectedFormation) {
            setReductionPartenaire(0);
            setCodePartenaireValide(false);
            setCodePartenaireInfo(null);
            return;
        }

        // Rechercher le code partenaire dans la liste
        const codePartenaireTrouve = ListeCodePartenaire.find(
            cp => cp.code_partenaire.toLowerCase() === code.toLowerCase()
        );

        if (codePartenaireTrouve) {
            // Vérifier si le code n'est pas déjà utilisé
            if (!codePartenaireTrouve.utilise_par || codePartenaireTrouve.utilise_par === '') {
                const formationSelectionnee = formation.find(f => f.reference === selectedFormation);
                if (formationSelectionnee) {
                    const prixBase = getPrixFormation(formationSelectionnee);
                    const pourcentageReduction = codePartenaireTrouve.pourcentageCeder || 0;
                    const montantReduction = (prixBase * pourcentageReduction) / 100;

                    setReductionPartenaire(montantReduction);
                    setCodePartenaireValide(true);
                    setCodePartenaireInfo(codePartenaireTrouve);
                }
            } else {
                // Code déjà utilisé
                setReductionPartenaire(0);
                setCodePartenaireValide(false);
                setCodePartenaireInfo(null);
            }
        } else {
            // Code non trouvé
            setReductionPartenaire(0);
            setCodePartenaireValide(false);
            setCodePartenaireInfo(null);
        }
    };

    useEffect(() => {
        verifierCodePromo(codePromo);
    }, [codePromo, selectedFormation, formData.type_financement]);

    useEffect(() => {
        verifierCodePartenaire(codePartenaire);
    }, [codePartenaire, selectedFormation, formData.type_financement, ListeCodePartenaire]);

    const getFormationLabel = (formation) => {
        const baseLabel = formation.nom;
        const periodLabel = formatFormationPeriod(formation.periode);

        // Choisir le prix en fonction du type de financement
        const prix = formData.type_financement === 'Particulier' && formation.prix_particulier > 0
            ? formation.prix_particulier
            : formation.prix;

        const priceLabel = prix ? `${prix.toLocaleString()} FCFA HT` : '';

        return `${baseLabel} (${periodLabel}) ${priceLabel ? `- ${priceLabel}` : ''}`;
    };

    const isValidDate = (dateString) => {
        if (!dateString) return false;
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date);
    };

    const normalizeDate = (dateString) => {
        if (!dateString) return null;

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
            const [day, month, year] = dateString.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        const date = new Date(dateString);
        if (isValidDate(date)) {
            return date.toISOString().split('T')[0];
        }

        return null;
    };

    const isDateList = (periode) => {
        if (!periode) return false;

        if (typeof periode === 'string') {
            try {
                const cleanedPeriode = periode.replace(/'/g, '"');
                const parsed = JSON.parse(cleanedPeriode);
                return Array.isArray(parsed) && parsed.length > 0;
            } catch (error) {
                return false;
            }
        }

        return Array.isArray(periode) && periode.length > 0;
    };

    const formatFormationPeriod = (periode) => {
        if (!periode || periode === '[]' || periode === '""' || periode === "''") {
            return "À la demande";
        }

        if (isDateList(periode)) {
            try {
                let dates;
                if (typeof periode === 'string') {
                    const cleanedPeriode = periode.replace(/'/g, '"');
                    dates = JSON.parse(cleanedPeriode);
                } else {
                    dates = periode;
                }

                const validDates = dates
                    .map(date => normalizeDate(date))
                    .filter(date => date !== null && isValidDate(new Date(date)))
                    .sort();

                if (validDates.length > 0) {
                    return validDates.map((date, index) => {
                        const dateObj = new Date(date);
                        return dateObj.toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit'
                        });
                    }).join(', ');
                }
            } catch (error) {
                console.warn('Erreur de parsing des dates:', error);
            }
        }

        if (typeof periode === 'string' && periode.trim() !== '') {
            return periode;
        }

        return '-';
    };

    // Fetch souscriptions data
    const fetchSouscriptions = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-souscriptions-utilisateur/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                console.log(data)
                setSouscriptions(data.souscriptions);
                if (data.souscriptions.length === 0) {
                    setShowTutorialModal(true);
                }
            } else {
                console.error('Erreur lors de la récupération des souscriptions');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    const handleRowClick = (souscription) => {
        setSelectedSouscription(souscription);
    };

    const handleCloseDetailModal = () => setShowDetailModal(false);

    // Filter souscriptions by search term
    const filteredSouscriptions = souscriptions.filter(s =>
        (s.utilisateur?.nom && s.utilisateur.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.utilisateur?.prenoms && s.utilisateur.prenoms.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.formation?.nom && s.formation.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.produit?.nom && s.produit.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.date_souscription && s.date_souscription.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // Sort souscriptions
    const sortedSouscriptions = [...filteredSouscriptions].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastSouscription = currentPage * itemsPerPage;
    const indexOfFirstSouscription = indexOfLastSouscription - itemsPerPage;
    const currentSouscriptions = sortedSouscriptions.slice(indexOfFirstSouscription, indexOfLastSouscription);
    const totalPages = Math.ceil(sortedSouscriptions.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleShowDetail = async (souscription) => {
        setSelectedSouscription(souscription);
        setDetailData(souscription);
        setShowDetailModal(true);
    };

    const [showSouscrireModal, setShowSouscrireModal] = useState(false);
    const [showFormationSelectionModal, setShowFormationSelectionModal] = useState(false);

    // Fonctions pour le modal de souscription
    const handleOpenSouscrireModal = () => {
        setShowSouscrireModal(true);
        setSelectedFormation('');
        setCodePromo('');
        setCodePartenaire('');
    };

    const handleCloseSouscrireModal = () => {
        setShowSouscrireModal(false);
    };

    const handleFormationSelection = (formation) => {
        setSelectedFormation(formation.reference);
        setSelectedProduits([]);
    };

    const handleProduitSelection = (produitId) => {
        setSelectedProduits([produitId]);
        setSelectedFormation('');
    };

    const handleSouscrire = async () => {
        if (!selectedFormation) {
            showAlert("Veuillez sélectionner une formation", "danger");
            return;
        }

        setIsLoadingButton(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOTE}/Souscrire/${user_id}/`, {
                ref_formation: selectedFormation, // Envoyer toujours un tableau au backend
                code_promo: codePromo,
                code_partenaire: codePartenaire,
                type_financement: formData.type_financement || 'Particulier'
            });

            showAlert(response.data.message, 'success');
            fetchSouscriptions();
            handleCloseSouscrireModal();
        } catch (error) {
            console.error('Erreur:', error);
            showAlert(error.response?.data?.error || "Erreur lors de la souscription", 'danger');
        } finally {
            setIsLoadingButton(false);
        }
    };

    const handleClearFormationSelection = () => {
        setSelectedFormation('');
        setCodePromo('');
        setCodePartenaire('');
    };

    // Fonctions pour le carrousel
    const handleNextItems = () => {
        const containerWidth = carouselRef.current?.offsetWidth || 0;
        const totalWidth = currentItems.length * 280;
        const maxTranslate = -(totalWidth - containerWidth);

        setTranslateX(prev => {
            const newTranslate = prev - (containerWidth / 2);
            return Math.max(newTranslate, maxTranslate);
        });
    };

    const handlePrevItems = () => {
        setTranslateX(prev => Math.min(prev + (carouselRef.current?.offsetWidth / 2 || 0), 0));
    };

    const carouselStyle = {
        display: 'flex',
        transition: 'transform 0.5s ease-in-out',
        transform: `translateX(${translateX}px)`,
        willChange: 'transform'
    };

    const currentItems = activeTab === 'formations' ? formation : produits;

    const [showTutorialModal, setShowTutorialModal] = useState(false);

    const handleCloseTutorial = () => {
        setShowTutorialModal(false);
        handleOpenSouscrireModal()
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaMoneyBill size={25} className='mr-2' /> Mes souscriptions
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Souscription-utilisateur`}> Mes souscriptions</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="justify-content-center align-items-center mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="justify-content-center align-items-center">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Mes souscriptions</h5>
                                <div className='d-flex'>
                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={handleOpenSouscrireModal}
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-1">
                                            Souscrire
                                        </span>
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <div className="input-group" style={{ width: '300px' }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('formation.nom')}>
                                                                Elément {sortConfig.key === 'formation.nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell text-center' onClick={() => handleSort('date_souscription')}>
                                                                Date souscription {sortConfig.key === 'date_souscription'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell text-center' onClick={() => handleSort('montant_paye')}>
                                                                Montant payé {sortConfig.key === 'montant_paye'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell text-center' onClick={() => handleSort('reste_a_payer')}>
                                                                Reste à payer {sortConfig.key === 'reste_a_payer'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell text-center' onClick={() => handleSort('montant_de_reduction')}>
                                                                Réduction {sortConfig.key === 'montant_de_reduction'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentSouscriptions.length > 0 ? currentSouscriptions.map((souscription) => (
                                                                <tr
                                                                    key={souscription.id}
                                                                    className={`bg-white ${selectedSouscription && selectedSouscription.id === souscription.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(souscription)}
                                                                >
                                                                    <td>
                                                                        {souscription.formation?.nom || souscription.produit?.nom || ''}
                                                                        <div className='lesInfos'>
                                                                            <small>Produit: {souscription.produit?.nom || 'Aucun'}</small>
                                                                            <small>Date: {new Date(souscription.date_souscription).toLocaleDateString()}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell text-center">{new Date(souscription.date_souscription).toLocaleDateString()}</td>
                                                                    <td className="d-none d-md-table-cell text-center">{parseInt(souscription.montant_paye || 0).toLocaleString('fr-FR')} FCFA HT</td>
                                                                    <td className="d-none d-md-table-cell text-center">{parseInt(souscription.reste_a_payer || 0).toLocaleString('fr-FR')} FCFA HT</td>
                                                                    <td className="d-none d-md-table-cell text-center">{parseInt(souscription.montant_de_reduction || 0).toLocaleString('fr-FR')} FCFA HT</td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">Aucune souscription trouvée</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSouscription + 1} à ${Math.min(indexOfLastSouscription, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Detail Modal */}
            <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="lg">
                <Modal.Header>
                    <Modal.Title>Détails de la souscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {detailData ? (
                        <div className="row">
                            <div className="col-md-6">
                                <h5>Informations utilisateur</h5>
                                <div className="detail-item">
                                    <span className="detail-label">Nom:</span>
                                    <span className="detail-value">{detailData.utilisateur?.nom} {detailData.utilisateur?.prenoms}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Email:</span>
                                    <span className="detail-value">{detailData.utilisateur?.email}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Téléphone:</span>
                                    <span className="detail-value">{detailData.utilisateur?.tel}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h5>Détails souscription</h5>
                                <div className="detail-item">
                                    <span className="detail-label">Formation:</span>
                                    <span className="detail-value">{detailData.formation?.nom || 'Aucune'}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Produit:</span>
                                    <span className="detail-value">{detailData.produit?.nom || 'Aucun'}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Date:</span>
                                    <span className="detail-value">{new Date(detailData.date_souscription).toLocaleDateString()}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Montant payé:</span>
                                    <span className="detail-value">{parseInt(detailData.montant_paye || 0).toLocaleString('fr-FR')} FCFA HT</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Reste à payer:</span>
                                    <span className="detail-value">{parseInt(detailData.reste_a_payer || 0).toLocaleString('fr-FR')} FCFA HT</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p>Aucune information disponible</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDetailModal}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Souscription */}
            <Modal show={showSouscrireModal} onHide={handleCloseSouscrireModal} size="lg">
                <Modal.Header>
                    <Modal.Title>Nouvelle souscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                        </div>
                    ) : (
                        <>
                            <Form.Group className="mb-4">
                                <Form.Label>
                                    <strong>Sélectionnez une formation</strong>
                                </Form.Label>
                                
    <Select
        options={formation.map(item => ({
            value: item.reference,
            label: getFormationLabel(item),
            data: item
        }))}
        value={
            selectedFormation
                ? {
                    value: selectedFormation,
                    label: getFormationLabel(formation.find(f => f.reference === selectedFormation)) || selectedFormation,
                }
                : null
        }
        onChange={(selectedOption) => {
            if (selectedOption) {
                setSelectedFormation(selectedOption.value);
                setSelectedProduits([]);
                // Réinitialiser les codes promo et partenaire
                setCodePromo('');
                setCodePartenaire('');
            } else {
                setSelectedFormation('');
            }
        }}
        placeholder="Recherchez et sélectionnez une formation..."
        isSearchable
        isClearable
        className="basic-select"
        classNamePrefix="select"
        // DÉSACTIVER TOUTES LES VALIDATIONS
        filterOption={null} // Désactive le filtrage
        isValidNewOption={() => true} // Permet toutes les options
        getOptionValue={(option) => option.value}
        getOptionLabel={(option) => option.label}
        // Permettre la création d'options même si elles ne sont pas dans la liste
        createOptionPosition="first"
        formatCreateLabel={(inputValue) => `Créer "${inputValue}"`}
        onCreateOption={(inputValue) => {
            // Permettre à l'utilisateur de créer une nouvelle option
            const newOption = {
                value: inputValue,
                label: inputValue
            };
            setSelectedFormation(inputValue);
        }}
        noOptionsMessage={() => "Commencez à taper pour rechercher"}
        styles={{
            control: (base) => ({
                ...base,
                border: '1px solid #dee2e6',
                borderRadius: '0.375rem',
                minHeight: '45px',
                '&:hover': {
                    borderColor: '#86b7fe'
                }
            }),
            option: (base, state) => ({
                ...base,
            })
        }}
    />
                            </Form.Group>

                            {/* Indicateur de sélection */}
                            {selectedFormation && (
                                <div className="alert alert-info mb-3 py-2">
                                    <small>
                                        <strong>Formation sélectionnée : </strong>
                                        {formation.find(f => f.reference === selectedFormation)?.nom}
                                        <br />
                                        <strong>Prix : </strong>
                                        {getPrixFormation(formation.find(f => f.reference === selectedFormation)).toLocaleString()} FCFA HT
                                        {(reduction > 0 || reductionPartenaire > 0) && (
                                            <span className="text-success ml-2">
                                                (Économie de {(reduction + reductionPartenaire).toLocaleString()} FCFA HT)
                                            </span>
                                        )}
                                    </small>
                                </div>
                            )}

                            {/* Formulaire des codes */}
                            <div className="row">
                                <div className="col-md-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Code promo (optionnel)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Entrez votre code promo"
                                            value={codePromo}
                                            onChange={(e) => {
                                                setCodePromo(e.target.value);
                                            }}
                                            disabled={!selectedFormation}
                                            className={!selectedFormation ? 'bg-light' : ''}
                                        />
                                        {!selectedFormation && (
                                            <Form.Text className="text-muted">
                                                Sélectionnez d'abord une formation
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Code partenaire (optionnel)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Entrez votre code partenaire"
                                            value={codePartenaire}
                                            onChange={(e) => setCodePartenaire(e.target.value)}
                                            disabled={!selectedFormation}
                                            className={!selectedFormation ? 'bg-light' : ''}
                                        />
                                        {!selectedFormation && (
                                            <Form.Text className="text-muted">
                                                Sélectionnez d'abord une formation
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseSouscrireModal}>
                        Annuler
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSouscrire}
                        disabled={isLoadingButton || !selectedFormation}
                    >
                        {isLoadingButton ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                En cours...
                            </>
                        ) : (
                            'Souscrire'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showTutorialModal} onHide={handleCloseTutorial} size="lg" centered>
                <Modal.Header>
                    <Modal.Title className="d-flex align-items-center">
                        <FaInfoCircle className="mr-2" />
                        Bienvenue dans vos souscriptions !
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="card h-100 border-0 shadow-sm">
                                <div className="card-body text-center">
                                    <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '60px', height: '60px' }}>
                                        <FaPlus className="text-" size={20} />
                                    </div>
                                    <h6 className="card-title">Étape 1</h6>
                                    <p className="card-text small">Cliquez sur le bouton <strong>"Souscrire"</strong> en haut à droite</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div className="card h-100 border-0 shadow-sm">
                                <div className="card-body text-center">
                                    <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '60px', height: '60px' }}>
                                        <FaSearch className="text-" size={20} />
                                    </div>
                                    <h6 className="card-title">Étape 2</h6>
                                    <p className="card-text small">Sélectionnez une <strong>formation</strong> ou un <strong>produit</strong> dans la liste</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div className="card h-100 border-0 shadow-sm">
                                <div className="card-body text-center">
                                    <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '60px', height: '60px' }}>
                                        <FaTicketAlt className="text-" size={20} />
                                    </div>
                                    <h6 className="card-title">Étape 3</h6>
                                    <p className="card-text small">Ajoutez vos codes promo ou partenaire si vous en avez</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div className="card h-100 border-0 shadow-sm">
                                <div className="card-body text-center">
                                    <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '60px', height: '60px' }}>
                                        <FaCheck className="text-" size={20} />
                                    </div>
                                    <h6 className="card-title">Étape 4</h6>
                                    <p className="card-text small">Cliquez sur le bouton <strong>Souscrire</strong> pour confirmer votre souscription.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleCloseTutorial} className="d-flex align-items-center">
                        Commencer maintenant
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ListeSouscriptions;